import { TESTIDS } from "@/constants/testIds";
import { LEVEL_STYLES } from "@/lib/enums";
import { ArrowUpRight } from "lucide-react";
import { t } from "@/lib/i18n";

const EPA_LINK =
  "https://www.epa.gov/radon/epa-maps-radon-zones-and-supporting-documents-state";

const LatestReadingCard = ({ reading }) => {
  if (!reading) {
    return (
      <div className="card-flat" data-testid={TESTIDS.latestReadingCard}>
        <p className="eyebrow">{t("Latest reading")}</p>
        <h2 className="font-serif text-2xl mt-2 text-[#1C201F]">
          {t("No readings yet.")}
        </h2>
        <p className="text-sm text-[#5C6661] mt-2 leading-relaxed">
          {t("Once you enter a radon reading, your action level and personalized next steps will appear here.")}
        </p>
      </div>
    );
  }

  const c = reading.classification;
  const style = LEVEL_STYLES[c.level] || LEVEL_STYLES["consider"];

  return (
    <div
      className="card-flat overflow-hidden"
      data-testid={TESTIDS.latestReadingCard}
      style={{ background: style.bg, borderColor: style.border }}
    >
      <p className="eyebrow" data-testid={TESTIDS.latestReadingLevel} style={{ color: style.text }}>
        {t("Your Radon Action Level:")}{" "}{t(c.label)}
      </p>
      <div className="mt-4 flex items-baseline gap-3">
        <span
          className="font-serif text-6xl leading-none text-[#1C201F]"
          data-testid={TESTIDS.latestReadingValue}
        >
          {reading.pci_l.toFixed(1)}
        </span>
        <span className="text-lg text-[#5C6661]">{t("pCi/L")}</span>
      </div>
      <p
        className="mt-5 text-base text-[#1C201F] leading-snug"
        data-testid={TESTIDS.latestReadingHeadline}
      >
        {t(c.headline)}
      </p>
      <p
        className="mt-3 text-sm text-[#5C6661] leading-relaxed"
        data-testid={TESTIDS.latestReadingSummary}
      >
        {t(c.summary)}
      </p>
      <a
        href={EPA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1 mt-4 text-xs font-semibold text-[#2F524A] hover:text-[#243E38] underline underline-offset-2 decoration-[#2F524A]/40 hover:decoration-[#2F524A] transition-colors"
        data-testid={TESTIDS.epaLink}
      >
        {t("Learn more on EPA.gov")}
        <ArrowUpRight size={13} />
      </a>
      <div className="mt-5 flex flex-wrap gap-x-6 gap-y-1 text-xs text-[#5C6661]">
        <span>{t("Range:")}{" "}<span className="text-[#1C201F] font-semibold">{c.range}</span></span>
        <span>{t("Test date:")}{" "}<span className="text-[#1C201F] font-semibold">{reading.reading_date}</span></span>
      </div>
    </div>
  );
};

export default LatestReadingCard;
